import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function PrivateNotice() {
  return (
    <Container fluid className="project-section">
      <Container>
        <Row style={{ paddingTop: "80px", paddingBottom: "80px" }}>
          <Col md={12} className="project-card">
            <h1 className="project-heading">
              Project <strong className="purple">Private</strong>
            </h1>
            <p style={{ marginTop: 20 }}>
              This project is private and not publicly accessible at the moment.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default PrivateNotice;


